import React, { useEffect, useState } from "react";
import Header from "../../../../Components/Header";
import DynamicTable from "../../../../Components/Table";
import CommonModal from "../../../../Components/Modals/index";
import { BASE_DOMAIN, columnReport, columns, headerMappingData, headerMappingDataRev, rows, YEAR_LIST } from "../../../../utils/constants";
import { useLocation, useNavigate, createSearchParams } from "react-router-dom";
import { useDeleteCompanyMutation, useFetchcompanyQuery, useToggleCompanyMutation } from "../../../../features/Group/groupSlice";
import { Menu, Modal } from "@mui/material";
import { Autocomplete, TextField, Checkbox, Popper } from "@mui/material";
import "./GroupTable.scss";
import * as XLSX from "xlsx";
import ReportTableGeneration from "../../../../Components/ReportTable";
import {
  useGenerateReportMutation,
  useReportbackupMutation,
  useReportcompanyQuery,
  useUpdateStatusMutation,
} from "../../../../features/Report/reportSlice";
import { useToast } from "../../../ToastProvider";
import {
  DeleteOutlineOutlinedIcon,
  EditOutlinedIcon,
  ToggleOffOutlinedIcon,
  ToggleOnIcon,
  KeyboardArrowDownIcon,
  LockIcon,
  BackupIcon,
  LockOpenIcon,
  DownloadIcon,
} from "../../../../utils/icons";


const CustomPopper = (props) => <Popper {...props} placement="bottom-start" />;

const SubAdminReportTable = () => {
  const location = useLocation();
  const { showSuccess, showError } = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [reportDataList, setReportDataList] = useState({});
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    description: "",
    icon: "",
  });
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const [dropdown, setDropdown] = useState([]);
  const [finalDwn, setFinalDwn] = useState([]);
  const [filters, setFilters] = useState({ page: 1, limit: 10 });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [row, setRow] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [modal, setModal] = useState(false);
  const [updateStatus, { isLoading: statusLoad }] = useUpdateStatusMutation();
  const [generateReport, { data: reportData, error, isLoading: reportLoading }] = useGenerateReportMutation();
  const [reportbackup, { data: reportBack, isLoading: backLoading }] = useReportbackupMutation();
  const currentYear = new Date().getFullYear(); // Get the current year
  const [selectedYear, setSelectedYear] = useState(currentYear); // Set default value as the current year

  const handleChange = (event) => {
    setSelectedYear(event.target.value); // Update the selected year
  };
  const [genModal, setGenModal] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);
  const [selectReportType, setSelectReportType] = useState("");

  const {
    data = { data: [] },
    error: comperr,
    isLoading,
    refetch,
  } = useReportcompanyQuery(`${localStorage.getItem("group")}?page=${currentPage}&limit=${rowsPerPage}`);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const selectAllOption = "Select All";


  const reportOptions = [
    { value: "Report_1a_Large", label: "Report 1A Large" },
    { value: "Report_1a_Small", label: "Report 1B Small" },
    { value: "Report_1a_CCA", label: "Report 1C CCA" },
    { value: "Report_2a_TotalSpend", label: "Report 2A TotalSpend" },
    { value: "Report_2a_Subcontracting", label: "Report 2B Subcontracting" },
    { value: "Report_3a_Large", label: "Report 3A Large" },
    { value: "Report_3b_Small", label: "Report 3B Small" },
    { value: "Report_3c_Large", label: "Report 3C Large" },
    { value: "Report_3d_Small", label: "Report 3D Small" },
    { value: "Report_4a_Large", label: "Report 4A Large" },
    { value: "Report_4a_Small", label: "Report 4B Small" },
    { value: "Report_5a_DVBE", label: "Report 5A DVBE" },
    { value: "Report_5b_LGBTBE", label: "Report 5B LGBTBE" },
    { value: "Report_6_DIRECT_BY_YEAR", label: "Report 6(Direct By Year)" },
  ];

  console.log("DTF", data);
  const updatedData = data?.records?.map((obj) => ({
    ...obj,
    compId: obj?.company?.companyId,
  }));

  console.log("UPD", updatedData);
  const navigate = useNavigate();
  const [deleteCompany, { isLoading: delLoading, isSuccess, error: anyError }] = useDeleteCompanyMutation();
  const [toggleCompany, { isLoading: toggleLoading, isSuccess: togSuccess, isError }] = useToggleCompanyMutation();

  const handlePageChange = (page) => {
    setFilters({
      ...filters,
      page: page,
    });
    setCurrentPage(page);
  };

  console.log("DATA", data, isLoading, queryParams.get("grp"), queryParams.get("grpname"), filters);

  const handleSearchChange = (value) => {
    setSearchValue(value);
    setFilters({ ...filters, search: value });
  };

  const handleRowValue = (val) => {
    setRow(val);
    console.log(val, "VLLLLL");
    // if (val.status === "Inactive") {
    if (val.status === "Active") {
      setDropdown([
        {
          name: "Lock Report",
          icon: <LockIcon />,
          id: 1,
        },
        {
          name: "Manage Backup",
          icon: <BackupIcon />,
          id: 2,
        },
        {
          name: "Download Data",
          icon: <DownloadIcon />,
          id: 3,
        },
      ]);
    } else {
      setDropdown([
        {
          name: "Unlock Report",
          icon: <LockOpenIcon />,
          id: 1,
        },
        {
          name: "Manage Backup",
          icon: <BackupIcon />,
          id: 2,
        },
        {
          name: "Download Data",
          icon: <DownloadIcon />,
          id: 3,
        },
      ]);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    console.log("vv", parseInt(event.target.value, 10));
    setRowsPerPage(parseInt(event.target.value, 10));
    const newLimit = parseInt(event.target.value, 10);
    setFilters((prevFilters) => ({
      ...prevFilters,
      limit: newLimit,
      page: 1,
    }));
    setCurrentPage(1);
  };

  const handleBackup = async () => {
    try {
      const result = await reportbackup({ id: row.id }).unwrap();
      console.log("RGG", result);
      showSuccess({
        body: "Backup Successful",
      });
      refetch();
    } catch (err) {
      showError({
        title: "Error!",
        body: err?.data?.message || err?.status || "something went wrong",
      });
    }
  };

  const handleMenuItem = (val) => {
    if (val.id === 1) {
      if (row.status === "Active") {
        setModalData({
          title: "Lock Report",
          description: "Are you sure you want to lock this Report?",
          icon: false,
        });
      } else {
        setModalData({
          title: "Unlock Report",
          description: "Are you sure you want to Unlock this Report?",
          icon: false,
        });
      }

      setModal(true);
    }
    if (val.id === 2) {
      handleBackup();
    }
    if (val.id === 3) {
      setDownloadModal(true);
      console.log("mmn",row)
      const keysArray = row?.customFields?.map(item => item?.fieldName);
      const listD = Object.entries(row)
        .filter(([key, value]) => value)
        .map(([key]) => key);
      const test = listD.map((key) => headerMappingData[key]).filter((value) => value !== undefined);
      setFinalDwn([...test,...keysArray]);
    }
  };

  const handleReset = () => {
    setFilters({
      page: 1,
      limit: 10,
    });
  };

  useEffect(() => {
    console.log("Filters updated:", filters);
    refetch();
  }, [location.pathname, filters]);
  const handleSort = () => {
    setFilters({
      ...filters,
    });
  };

  console.log("????", selectedCategories);

  const handleBack = () => {
    navigate("/super/report");
  };

  const handleConfirmAction = async () => {
    try {
      if (modalData.title === "Lock Report") {
        const result = await updateStatus({ id: row.id, payload: { status: "Locked" } }).unwrap();
        showSuccess({
          body: "Status Updated Successfully",
        });
        refetch();
      } else if (modalData.title === "Unlock Report") {
        const result = await updateStatus({ id: row.id, payload: { status: "Active" } }).unwrap();
        showSuccess({
          body: "Status Updated Successfully",
        });
        refetch();
      } else {
        const result = await toggleCompany(row.id).unwrap();
        refetch();
      }
    } catch (err) { }
    setModal(false);
  };

  const handleAction1Click = () => {
    setGenModal(true);
  };

  const handleChangeDown = (event, newValue) => {
    if (newValue.includes(selectAllOption)) {
      // If "Select All" is clicked, toggle all options
      if (selectedCategories.length === finalDwn.length) {
        setSelectedCategories([]); // Deselect all
        setIsSelectAllChecked(false);
      } else {
        setSelectedCategories(finalDwn); // Select all
        setIsSelectAllChecked(true);
      }
    } else {
      setSelectedCategories(newValue); // Normal selection
    }

    // Update the input field text
    setSearchQuery(newValue.filter((item) => item !== selectAllOption).join(", "));
  };

  const handleClose = () => {
    setGenModal(false);
    setDownloadModal(false);
    setSelectedCategories([])
  };

  const handleGenerate = async () => {
    console.log("Generate button clicked.");
    if (selectReportType) {
      if (selectReportType === "Report_1a_Large" || selectReportType === "Report_1a_Small" || selectReportType === "Report_1a_CCA") {
        navigate({
          pathname: "/sub/report/list/generate",
          search: `?${createSearchParams({ year: selectedYear, reportType: selectReportType, groupId: localStorage.getItem("group") })}`,
        });
      }
      if (selectReportType === "Report_2a_TotalSpend" || selectReportType === "Report_2a_Subcontracting") {
        navigate({
          pathname: "/sub/report/list/generate2",
          search: `?${createSearchParams({ year: selectedYear, reportType: selectReportType, groupId: localStorage.getItem("group") })}`,
        });
      }
      if (
        selectReportType === "Report_3a_Large" ||
        selectReportType === "Report_3b_Small" ||
        selectReportType === "Report_3c_Large" ||
        selectReportType === "Report_3d_Small"
      ) {
        navigate({
          pathname: "/sub/report/list/generate3",
          search: `?${createSearchParams({ year: selectedYear, reportType: selectReportType, groupId: localStorage.getItem("group") })}`,
        });
      }
      if (selectReportType === "Report_4a_Large" || selectReportType === "Report_4a_Small") {
        navigate({
          pathname: "/sub/report/list/generate4",
          search: `?${createSearchParams({ year: selectedYear, reportType: selectReportType, groupId: localStorage.getItem("group") })}`,
        });
      }
      if (selectReportType === "Report_5a_DVBE" || selectReportType === "Report_5b_LGBTBE") {
        navigate({
          pathname: "/sub/report/list/generate5",
          search: `?${createSearchParams({ year: selectedYear, reportType: selectReportType, groupId: localStorage.getItem("group") })}`,
        });
      }
      if (selectReportType === "Report_6_DIRECT_BY_YEAR") {
        navigate({
          pathname: "/sub/report/list/generate6",
          search: `?${createSearchParams({ year: selectedYear, reportType: selectReportType, groupId: localStorage.getItem("group") })}`,
        });
      }
      handleClose();
    } else {
      showError({
        body: "Please Select Report Type",
      });
    }
  };

  const handleReportTypeChange = (evt) => {
    setSelectReportType(evt.target.value);
  };

  const handleDownload = () => {
    console.log("Download button clicked", selectedCategories, row);
    let newDataList = Object.keys(headerMappingDataRev)
      .filter((key) => selectedCategories.includes(key)) // Filter keys that exist in the data array
      .reduce((obj, key) => {
        obj[key] = headerMappingDataRev[key]; // Add the key-value pair to the new object
        return obj;
      }, {});

      let customList = row?.customFields
      ?.filter(itm => selectedCategories.includes(itm?.fieldName))
      ?.reduce((acc, itm) => {
        acc[itm.fieldName] = itm.value;
        return acc;
      }, {});

      console.log("cust",customList)

      // newDataList = {...newDataList,...customList}

    // Prepare the horizontal data
    let horizontalData = {
      ...Object.keys(newDataList).reduce((acc, key) => {
        acc[key] = row[newDataList[key]] || null; // Fetch corresponding value
        return acc;
      }, {}),
    };

    horizontalData = {...horizontalData,...customList}

    console.log(horizontalData); // Debug to ensure the data is structured correctly

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet([horizontalData], { skipHeader: false });

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write the workbook to a file and trigger download
    XLSX.writeFile(workbook, "data-horizontal.xlsx");

    setDownloadModal(false);
    setSelectedCategories([])
  };


  return (
    <div>
      <>
        <Header
          title={localStorage.getItem("groupName")}
          // description={`#${queryParams.get("grp")}` || "#ID0000"}
          // searchValue={searchValue}
          // isSearchDisable={true}
          btnText='Generate Report'
          isSearchField={false}
          // searchText='Search by Company Name'
          isIcon={false}
          isFilter={false}
          isback={false}
          // onFilterClick={handleFilter}
          onReset={handleReset}
          // onSearchChange={handleSearchChange}
          onAction1Click={handleAction1Click}
          handleBack={handleBack}
        />
        <DynamicTable
          columns={columnReport}
          rows={updatedData || []}
          isLoading={isLoading}
          onClick={handleSort}
          total={Math.ceil(data?.total / rowsPerPage)}
          dropMenuList={dropdown}
          currentPage={currentPage}
          handleAction={handleRowValue}
          handleMenu={handleMenuItem}
          // page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </>
      {/* <>
          <ReportHeader type={reportType} />
          <ReportTableGeneration reportType={reportType} dataList={reportDataList} year={selectedYear} />
        </> */}

      {/* {console.log(reportType, "reportType")} */}
      {modal && (
        <CommonModal
          setIsOpenPopUp={setModal}
          open={modal}
          isLoading={statusLoad}
          handleDelete={handleConfirmAction}
          item={{
            title: modalData.title,
            description: modalData.description,
            icon: modalData.icon,
          }}
        />
      )}
      {genModal && (
        <Modal open={genModal} onClose={handleClose} aria-labelledby='modal-title' aria-describedby='modal-description'>
          <div className='modal'>
            <div className='modal_container'>
              <div className='heading_container'>
                <p className='heading_values'>Select the Report type</p>
                <p className='heading_values_container'>
                  Choose the type of report you wish to generate from the options below. Each report type provides detailed insights tailored to your
                  needs.
                </p>
              </div>

              <div className='year_label'>Year</div>
              <div className='custom_select'>
                <select
                  className='year_selector'
                  value={selectedYear} // Set the current selected value
                  onChange={handleChange} // Handle changes
                >
                  <option value='' disabled>
                    Select Year
                  </option>
                  {YEAR_LIST.filter((year) => year <= new Date().getFullYear()).map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
                <KeyboardArrowDownIcon className='dropdown_icon' />
              </div>

              <div className='year_label'>Report Type</div>
              <div className='custom_select'>
                <select className='year_selector' value={selectReportType} onChange={handleReportTypeChange}>
                  <option value='' disabled>
                    Select report type
                  </option>
                  {/* ['Report_1a_Large', 'Report_1a_Small', 'Report_1a_CCA', 'Report_2a_TotalSpend'] */}
                  {reportOptions?.map((item, index) => {
                    return (
                      <option
                        style={{
                          color: "#666",
                          padding: "8px 10px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          fontSize: "14px",
                          backgroundColor: "#ffffff",
                        }}
                        value={item.value}>
                        {item.label}
                      </option>
                    );
                  })}
                </select>
                <KeyboardArrowDownIcon className='dropdown_icon' />
              </div>

              <div className='modal_buttons'>
                <button className='generate_btn' onClick={handleGenerate}>
                  Generate
                </button>
                <button className='cancel_btn' onClick={handleClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {downloadModal && (
        <Modal open={downloadModal} onClose={handleClose} aria-labelledby='modal-title' aria-describedby='modal-description'>
          <div className='modal'>
            <div className='modal_container'>
              <div className='heading_container'>
                <p className='heading_values'>Download Data</p>
                <p className='heading_values_container'>
                  By default, the data will contain all the data. To filter and customize it, type the name of the field in the textbox down below,
                  uncheck it and download your customized data.
                </p>
              </div>
              <div className='custom_select_data'>
                <Autocomplete
                  multiple
                  options={[selectAllOption, ...finalDwn]}
                  value={selectedCategories}
                  onChange={handleChangeDown}
                  PopperComponent={CustomPopper} // Ensures dropdown appears below input

                  ListboxProps={{
                    style: {
                      maxHeight: "200px", // Set max height for list
                      overflowY: "auto",
                      scrollbarWidth: "thin" // Ensure smooth scrolling
                    },
                  }}
                  renderOption={(props, option, { selected }) => (

                    <li {...props} style={{ fontSize: "12px" }}>
                      <Checkbox
                        checked={option === selectAllOption ? (selectedCategories.length === finalDwn.length) : selectedCategories.includes(option)}
                        sx={{
                          padding: "0px",
                          transform: "scale(0.7)", // Reduce size
                        }} />
                      {option}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id="modal_body"
                      sx={{
                        maxHeight: "100px", // Allow slight expansion
                        overflowY: "auto", // Enables scrolling if needed
                        scrollbarWidth: "thin",
                        "& .MuiInputBase-root": {
                          alignItems: "center", // Align text properly
                        },
                        "& .MuiInputBase-input": {
                          padding: "8px", // Adjust padding
                        },
                      }}
                      placeholder="Search or Select"
                      variant="outlined"
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  )}
                  popupIcon={<KeyboardArrowDownIcon />}
                  style={{ width: "100%" }}
                />
              </div>

              <div className='modal_buttons'>
                <button className='generate_btn' onClick={handleDownload}>
                  Download
                </button>
                <button className='cancel_btn' onClick={handleClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default SubAdminReportTable;
